import React from "react";
import { RenderForm } from "../../utils/formUtils";
import useForm from "../../hooks/useForm";
import styled from "styled-components";
import { Stack } from "@mui/material";
import { FormButton } from "../../components/buttons/FormButton";
import { useFirebase } from "../../hooks/firebase/useFirebase";
import { LogoView } from "../../components/elements/LogoView";
import { useAccountDeletionForm } from "../../hooks/account-deletion/useAccountDeletionForm";
import { showMessage } from "../../components/message/GenericMessage";

export const AccountDeletionForm = () => {
  const { form, updateFormValues, onChange } = useForm({});
  const { loading } = useFirebase();
  const { formFields } = useAccountDeletionForm();

  function cleanUp() {
    updateFormValues({
      email: "",
    });
  }

  function submitRequest() {
    cleanUp();
  }

  const onSubmit = (e) => {
    e.preventDefault();
    submitRequest();
    showMessage("Request submitted successfully", "success");
  };

  return (
    <div className="flexCenter vh100">
      <Wrapper>
        <LogoView />
        <form onSubmit={onSubmit}>
          <FormWrapper>
            <Stack spacing={3}>
              <RenderForm
                form={form}
                onChange={onChange}
                fields={formFields}
                updateFormValues={updateFormValues}
              />
              <FormButton loading={loading}>Submit Request</FormButton>
            </Stack>
          </FormWrapper>
        </form>
      </Wrapper>
    </div>
  );
};

export const Wrapper = styled.div`
  padding: 20px;
  width: 30%;

  @media (max-width: 860px) {
    width: 100%;
  }
`;

export const FormWrapper = styled.div``;
